"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dxReactGridMaterialUi = require("@devexpress/dx-react-grid-material-ui");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _actionsColumn = require("../tables/actionsColumn");
var _dxReactCore = require("@devexpress/dx-react-core");
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles() {
  return {
    dialogPaper: {
      borderRadius: 0
    },
    chip: {
      marginBottom: '.5rem'
    },
    table: {
      maxWidth: '50%',
      // margin: '0 auto',
      marginBottom: '50px'
    },
    paper: {
      padding: '1rem'
    },
    alertChip: {
      backgroundColor: 'red',
      color: 'white',
      fontSize: 'inherit',
      width: '100%'
    }
  };
};
var getDelegationRows = function getDelegationRows(delegates, entity, page, tab, allPages, resources, language) {
  var users = delegates.users,
    entities = delegates.entities;
  var delegationRows = [];
  // Add survey level
  if (!(0, _lodash.isEmpty)(users)) {
    users.forEach(function (user) {
      delegationRows.push({
        name: user.name,
        email: user.email,
        accessDelegated: "".concat((0, _getResource.getResource)(resources, language, 'Label', 'Yearly Survey'))
      });
    });
  }

  // Add if in same entity
  if (!(0, _lodash.isEmpty)(entities) && !(0, _lodash.isEmpty)(entity)) {
    var curEntity = (0, _lodash.find)(entities, {
      entityID: entity.entityID
    });
    curEntity && !(0, _lodash.isEmpty)(curEntity.users) && curEntity.users.forEach(function (u) {
      delegationRows.push({
        name: u.name,
        email: u.email,
        entityID: entity.entityID,
        accessDelegated: "".concat((0, _getResource.getResource)(resources, language, 'Label', 'Yearly Survey'), " > ").concat(entity.entityName)
      });
    });
    if (curEntity && !(0, _lodash.isEmpty)(curEntity.categories)) {
      curEntity.categories.forEach(function (c) {
        //console.log('c.pageID: ', c.pageID); //c.pageID is always a string, in allPages its sometimes an int
        //console.log('allPages: ', allPages);
        c.users.forEach(function (u) {
          var pageName = '';
          var pageItem = (0, _lodash.find)(allPages, {
            pageId: c.pageID
          }) ? (0, _lodash.find)(allPages, {
            pageId: c.pageID
          }) : (0, _lodash.find)(allPages, {
            pageId: Number(c.pageID)
          });
          if (pageItem) {
            pageName = pageItem.pageName;
          }
          if (pageItem != '') {
            delegationRows.push({
              accessDelegated: "".concat((0, _getResource.getResource)(resources, language, 'Label', 'Yearly Survey'), " > ").concat(entity.entityName, " > ").concat(pageName),
              email: u.email,
              entityID: entity.entityID,
              name: u.name,
              pageID: c.pageID
            });
          }
        });
      });
    }
  }
  return delegationRows;
};
var DelegateModal = /*#__PURE__*/function (_Component) {
  function DelegateModal(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DelegateModal);
    _this = _callSuper(this, DelegateModal, [props]);
    (0, _defineProperty2["default"])(_this, "isPageSelected", function (id) {
      return _this.state.selectedPages.indexOf(id) !== -1;
    });
    (0, _defineProperty2["default"])(_this, "handleSelectPage", function (event, id) {
      var selectedPages = _this.state.selectedPages;
      var selectedIndex = selectedPages.indexOf(id);
      var newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selectedPages, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selectedPages.slice(1));
      } else if (selectedIndex === selectedPages.length - 1) {
        newSelected = newSelected.concat(selectedPages.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selectedPages.slice(0, selectedIndex), selectedPages.slice(selectedIndex + 1));
      }
      _this.setState({
        selectedPages: newSelected
      });
    });
    (0, _defineProperty2["default"])(_this, "handleSelectAllPages", function (event, pages) {
      if (event.target.checked) {
        _this.setState({
          selectedPages: pages.map(function (page) {
            return page.pageId;
          })
        });
        return;
      }
      _this.setState({
        selectedPages: []
      });
    });
    var _this$props = _this.props,
      delegates = _this$props.delegates,
      entity = _this$props.entity,
      _page = _this$props.page,
      tab = _this$props.tab,
      allPages = _this$props.allPages,
      resources = _this$props.resources,
      language = _this$props.language,
      sendingEmail = _this$props.sendingEmail;
    _this.state = {
      delegationRows: [],
      selectedPages: [],
      email: '',
      emailIsValid: true,
      nameIsValid: true,
      delegateNotAdded: false,
      isDirty: false,
      name: '',
      newDelegates: [],
      note: '',
      sendPlainText: false,
      columns: [{
        name: 'name',
        title: (0, _getResource.getResource)(resources, language, 'Label', 'Delegate Name')
      }, {
        name: 'email',
        title: (0, _getResource.getResource)(resources, language, 'Label', 'Email Address')
      }, {
        name: 'accessDelegated',
        title: (0, _getResource.getResource)(resources, language, 'Label', 'Access Delegated')
      }]
    };
    _this.props.fullScreen = false;
    ['handleInputChange', 'addDelegate', 'handleClose', 'handleSend'].forEach(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(DelegateModal, _Component);
  return (0, _createClass2["default"])(DelegateModal, [{
    key: "getAddText",
    value: function getAddText() {
      var _this$props2 = this.props,
        survey = _this$props2.survey,
        entity = _this$props2.entity,
        page = _this$props2.page,
        tab = _this$props2.tab,
        resources = _this$props2.resources,
        language = _this$props2.language;
      var phrase1 = (0, _getResource.getResource)(resources, language, 'Message', 'You are providing');
      //You are providing access to Survey: Hospitalerne i Nordsjælland - EMRAM 2022 for entity: Hospitalerne i Nordsjælland
      //You are providing access to Hospitalerne i Nordsjælland - EMRAM 2022
      if (!(0, _lodash.isEmpty)(page) && !(0, _lodash.isEmpty)(tab)) {
        return "".concat(phrase1, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'access to'), " ").concat(survey.surveyName, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'for'), " ").concat(entity.entityName, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'for'), " ").concat((0, _getResource.getResource)(resources, language, 'Page', page.pageName), " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'for'), " ").concat((0, _getResource.getResource)(resources, language, 'Tab', tab.tabName));
      } else if (!(0, _lodash.isEmpty)(entity) && !(0, _lodash.isEmpty)(page)) {
        return "".concat(phrase1, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'access to section:'), " ").concat(page.pageName, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'on Survey:'), " ").concat(survey.surveyName, " ").concat((0, _getResource.getResource)(resources, language, 'Message', 'for entity:'), " ").concat(entity.entityName);
      } else if (!(0, _lodash.isEmpty)(entity)) {
        return (0, _getResource.getResource)(resources, language, 'Message', 'You are providing access to Survey: {SURVEY_NAME} for entity: {ENTITY_NAME}').replace('{SURVEY_NAME}', survey.surveyName).replace('{ENTITY_NAME}', entity.entityName);
        //return `${phrase1} ${getResource(resources, language, 'Message', 'access to Survey:')} ${survey.surveyName} ${getResource(resources, language, 'Message', 'for entity:')} ${entity.entityName}`;
      }

      //return `${phrase1} ${getResource(resources, language, 'Message', 'access to')} ${survey.surveyName}`;
      return (0, _getResource.getResource)(resources, language, 'Message', 'You are providing access to {SURVEY_NAME}').replace('{SURVEY_NAME}', survey.surveyName);
    }
  }, {
    key: "addDelegate",
    value: function addDelegate() {
      var _this$state = this.state,
        name = _this$state.name,
        email = _this$state.email;
      var _this$props3 = this.props,
        entity = _this$props3.entity,
        page = _this$props3.page;
      if (name === '') {
        this.setState({
          nameIsValid: false
        });
        return;
      } else if (!this.isValidEmailAddress(email)) {
        this.setState({
          emailIsValid: false
        });
        return;
      }
      if (!this.hasDelegation(email)) {
        var newDelegates = [].concat(this.state.newDelegates);
        var delegate = {
          name: name,
          email: email
        };
        if (!(0, _lodash.isEmpty)(page)) {
          delegate.pageID = page.pageId;
          delegate.pageID = delegate.pageID.toString();
        }
        if (!(0, _lodash.isEmpty)(entity)) {
          delegate.entityID = entity.entityID;
        }
        newDelegates.push(delegate);
        this.setState({
          newDelegates: newDelegates,
          name: '',
          email: '',
          emailIsValid: true,
          delegateNotAdded: false
        });
      }
    }
  }, {
    key: "deleteNewDelegate",
    value: function deleteNewDelegate(delegate) {
      var email = delegate.email;
      var newDelegates = [].concat(this.state.newDelegates);
      var delegateIndex = (0, _lodash.findIndex)(newDelegates, {
        email: email
      });
      newDelegates.splice(delegateIndex, 1);
      this.setState({
        newDelegates: newDelegates
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      var _e$currentTarget = e.currentTarget,
        name = _e$currentTarget.name,
        value = _e$currentTarget.value;
      if (name === 'email' || name === 'name') {
        if (name === 'email' && this.hasDelegation(value)) {
          this.setState((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, value), "emailIsValid", false));
          return;
        }
        this.setState((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, value), "emailIsValid", true), "nameIsValid", true));
      }
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "isValidEmailAddress",
    value: function isValidEmailAddress(email) {
      return !!email.match(/.+@.+/);
    }
  }, {
    key: "hasDelegation",
    value: function hasDelegation(email) {
      var _this$props4 = this.props,
        delegates = _this$props4.delegates,
        entity = _this$props4.entity,
        page = _this$props4.page,
        tab = _this$props4.tab;
      var newDelegates = this.state.newDelegates;

      // Check if email is in new delegates array or at the survey level
      if ((0, _lodash.findIndex)(newDelegates, {
        email: email
      }) !== -1 || (0, _lodash.findIndex)(delegates.users, {
        email: email
      }) !== -1) {
        return true;
      }

      // Check if email in delegates at entity level
      if (!(0, _lodash.isEmpty)(entity)) {
        var entityDelegates = (0, _lodash.find)(delegates.entities, {
          entityID: entity.entityID
        });
        if (!(0, _lodash.isEmpty)(entityDelegates) && (0, _lodash.findIndex)(entityDelegates.users, {
          email: email
        }) !== -1) {
          return true;
        }
      }

      // Check if email in delegates at page / tab level
      if (!(0, _lodash.isEmpty)(page)) {
        var entityIndex = (0, _lodash.findIndex)(delegates.entities, {
          entityID: entity.entityID
        });
        if (entityIndex !== -1) {
          var pageDelegates = (0, _lodash.find)(delegates.entities[entityIndex].categories, {
            pageID: page.pageId
          });
          if (!(0, _lodash.isEmpty)(pageDelegates) && (0, _lodash.findIndex)(pageDelegates.users, {
            email: email
          }) !== -1) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "getHelperText",
    value: function getHelperText(email, field) {
      var emailIsValid = this.state.emailIsValid;
      var _this$props5 = this.props,
        resources = _this$props5.resources,
        language = _this$props5.language;
      if (this.hasDelegation(email)) {
        return (0, _getResource.getResource)(resources, language, 'Message', 'Email has delegation already');
      }
      if (!emailIsValid) {
        return (0, _getResource.getResource)(resources, language, 'Message', 'Must be a valid email');
      }
      return '';
    }
  }, {
    key: "handleSend",
    value: function handleSend(newDelegates) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectedPages = _this$state2.selectedPages,
        sendPlainText = _this$state2.sendPlainText,
        name = _this$state2.name,
        email = _this$state2.email;
      var page = this.props.page;
      if (name.length > 0 || email.length > 0) {
        this.setState({
          delegateNotAdded: true
        });
        return;
      } else {
        console.log('sendPlainText: ', sendPlainText);
        if (page) {
          var formattedDelegates = [];
          newDelegates.map(function (currDelegate) {
            //got a delegate, not loop through selectedPages and build the "categories" list
            var categories = [];
            selectedPages.map(function (currPage) {
              categories.push({
                pageID: currPage.toString()
              });
            });
            //DONT add the current page id for the section that was clicked on, because we dont have buttons on sections anymore
            //categories.push({ pageID: page.pageId });

            //now we have categories array build, create the payload for this delegate
            formattedDelegates.push({
              name: currDelegate.name,
              email: currDelegate.email,
              categories: categories,
              entityID: currDelegate.entityID
            });
          });
          this.setState({
            newDelegates: [],
            name: '',
            email: '',
            note: ''
          }, function () {
            return _this2.props.handleSend(formattedDelegates, sendPlainText);
          });
        } else {
          this.setState({
            newDelegates: [],
            name: '',
            email: '',
            note: ''
          }, function () {
            return _this2.props.handleSend(newDelegates, sendPlainText);
          });
        }
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this3 = this;
      this.setState({
        newDelegates: [],
        name: '',
        email: '',
        note: '',
        delegateNotAdded: false
      }, function () {
        return _this3.props.handleClose();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state3 = this.state,
        name = _this$state3.name,
        email = _this$state3.email,
        newDelegates = _this$state3.newDelegates,
        note = _this$state3.note,
        emailIsValid = _this$state3.emailIsValid,
        columns = _this$state3.columns,
        delegationRows = _this$state3.delegationRows,
        selectedPages = _this$state3.selectedPages,
        nameIsValid = _this$state3.nameIsValid;
      var _this$props6 = this.props,
        open = _this$props6.open,
        fullScreen = _this$props6.fullScreen,
        survey = _this$props6.survey,
        classes = _this$props6.classes,
        handleRemove = _this$props6.handleRemove,
        handleResend = _this$props6.handleResend,
        delegates = _this$props6.delegates,
        currentFilteredPageList = _this$props6.currentFilteredPageList,
        page = _this$props6.page,
        entity = _this$props6.entity,
        allPages = _this$props6.allPages,
        resources = _this$props6.resources,
        language = _this$props6.language;
      var actions = [{
        component: /*#__PURE__*/_react["default"].createElement(_material.Button, {
          className: classes.actionButtons,
          color: "primary",
          variant: "contained",
          style: {
            minHeight: '2.25rem',
            marginRight: '1rem'
          }
        }),
        text: "".concat((0, _getResource.getResource)(resources, language, 'Label', 'Resend')),
        action: function action(event, rowId) {
          handleResend(delegationRows[rowId], delegates, survey, _this4.state.sendPlainText);
        }
      }, {
        component: /*#__PURE__*/_react["default"].createElement(_material.Button, {
          className: classes.actionButtons,
          color: "primary",
          variant: "contained",
          style: {
            minHeight: '2.25rem'
          }
        }),
        text: "".concat((0, _getResource.getResource)(resources, language, 'Label', 'Remove')),
        action: function action(event, rowId) {
          handleRemove(delegationRows[rowId], delegates, survey);
        }
      }];

      //do not show sections list in delegate modal for health systems
      var showSectionList = true;
      if (entity && (entity.haEntityTypeID == 8 || entity.haEntityTypeID == 6)) {
        showSectionList = false;
      }
      var tableColumnExtensions = [{
        columnName: 'accessDelegated',
        wordWrapEnabled: true
      }];
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        maxWidth: "md",
        fullWidth: true,
        classes: {
          paper: classes.dialogPaper
        },
        fullScreen: fullScreen,
        open: open,
        onClose: this.handleClose,
        "aria-labelledby": "responsive-dialog-title"
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "responsive-dialog-title"
      }, survey.surveyName), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        style: {
          marginBottom: '1rem',
          fontWeight: 'bold'
        }
      }, this.getAddText()), /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        style: {
          marginBottom: '1rem'
        }
      }, process.env.REACT_APP_ENVIRONMENT !== "germantender" ? (0, _getResource.getResource)(resources, language, 'Message', 'Delegates below have been provided access at this time.') : 'Für Nutzer des DigitalRadar: Wir empfehlen die Fragen „Krankenhausinformationssystem (KIS)“ und „Ein Ticketsystem zur Bearbeitung und Analyse von Support-Anfragen ist im Einsatz.“ (Strukturen und Systeme / Softwareanwendungen) vor der Delegation zu beantworten, um eine spätere Verschiebung der Fragenummerierung zu vermeiden.'), !process.env.REACT_APP_DOD && process.env.REACT_APP_ENVIRONMENT !== 'germantender' && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
        control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          checked: this.state.sendPlainText,
          onChange: function onChange(event) {
            return _this4.setState({
              sendPlainText: event.target.checked
            });
          },
          name: "sendPlainText",
          color: "primary"
        }),
        label: (0, _getResource.getResource)(resources, language, 'Message', 'Send Delegate Emails in Plain Text?')
      }), process.env.REACT_APP_DOD && /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        style: {
          marginBottom: '.1rem'
        }
      }, (0, _getResource.getResource)(resources, language, 'Message', 'Delegate Email for DOD will send as Plain Text.')), /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.Grid, {
        rows: delegationRows,
        columns: columns,
        selection: [1]
      }, /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.VirtualTable, {
        height: 200
      }), /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.Table, {
        columnExtensions: tableColumnExtensions,
        messages: {
          noData: (0, _getResource.getResource)(resources, language, 'Label', 'No Data')
        }
      }), /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.TableHeaderRow, null), delegationRows.length > 0 && /*#__PURE__*/_react["default"].createElement(_actionsColumn.ActionsColumn, {
        actions: actions,
        width: 300
      }), /*#__PURE__*/_react["default"].createElement(_dxReactCore.Getter, {
        name: "tableColumns",
        computed: function computed(_ref) {
          var tableColumns = _ref.tableColumns;
          var columns = [].concat(tableColumns);
          columns[0].width = 120; //Delegate Name
          columns[1].width = 160; //Delegate Email
          columns[2].width = 300; //Access Delegated

          return [].concat(columns);
        }
      })), currentFilteredPageList && showSectionList &&
      /*#__PURE__*/
      //currentFilteredPageList only exists on facility view, only show the checkbox list if on facility view.
      _react["default"].createElement(_material.Paper, {
        className: classes.paper,
        square: true
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        style: {
          marginBottom: '1rem',
          fontWeight: 'bold'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Select sections to delegate')), /*#__PURE__*/_react["default"].createElement(_material.Table, {
        className: classes.table
      }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        indeterminate: selectedPages.length > 0 && selectedPages.length < currentFilteredPageList.length,
        checked: selectedPages.length === currentFilteredPageList.length,
        onChange: function onChange(event) {
          return _this4.handleSelectAllPages(event, currentFilteredPageList);
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, (0, _getResource.getResource)(resources, language, 'Label', 'Section Name')))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, currentFilteredPageList.map(function (currPage) {
        if (page.pageId !== currPage.pageId) {
          var isPageSelected = _this4.isPageSelected(currPage.pageId);
          return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
            hover: true,
            onClick: function onClick(event) {
              return _this4.handleSelectPage(event, currPage.pageId);
            },
            role: "checkbox",
            key: currPage.pageId,
            selected: isPageSelected
          }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
            padding: "checkbox"
          }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
            checked: isPageSelected
          })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, currPage.pageName));
        }
      })))), /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, {
        style: {
          marginTop: '1rem'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', "Add delegate's access to selected sections:")), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        spacing: 6
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        container: true,
        direction: "column",
        justifyContent: "space-between",
        spacing: 4
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        container: true,
        spacing: 4,
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        margin: "dense",
        label: (0, _getResource.getResource)(resources, language, 'Label', 'Name'),
        name: "name",
        error: !nameIsValid,
        helperText: !nameIsValid ? (0, _getResource.getResource)(resources, language, 'Message', 'Name is required') : '',
        onChange: this.handleInputChange,
        value: name
      }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        sm: 5
      }, /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        error: !emailIsValid || this.hasDelegation(email),
        helperText: this.getHelperText(email),
        label: (0, _getResource.getResource)(resources, language, 'Label', 'Email'),
        margin: "dense",
        name: "email",
        onChange: this.handleInputChange,
        value: email
      }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        disabled: !emailIsValid || !nameIsValid,
        color: "primary",
        style: {
          marginTop: '.5rem'
        },
        variant: "text",
        onClick: this.addDelegate
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Add')))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true
      }, newDelegates.map(function (delegate, index) {
        return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
          className: classes.chip,
          key: "".concat(delegate.email, "-").concat(index),
          label: "".concat(delegate.name, " <").concat(delegate.email, ">"),
          onDelete: function onDelete() {
            return _this4.deleteNewDelegate(delegate);
          },
          style: index < newDelegates.length ? {
            marginRight: '.5rem'
          } : {}
        });
      })))), this.state.delegateNotAdded && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Chip, {
        label: (0, _getResource.getResource)(resources, language, 'Label', 'Please click the Add button to add delegates prior to clicking Send.'),
        className: classes.alertChip
      })))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        onClick: function onClick() {
          return _this4.handleClose();
        },
        color: "primary"
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Dismiss')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        disabled: newDelegates.length === 0 || this.sendingEmail,
        onClick: function onClick() {
          return _this4.handleSend(newDelegates);
        },
        color: "primary",
        autoFocus: true
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Send'))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var delegates = props.delegates,
        entity = props.entity,
        page = props.page,
        tab = props.tab,
        allPages = props.allPages,
        resources = props.resources,
        language = props.language;
      var newState = _objectSpread({}, state);
      newState.delegationRows = getDelegationRows(delegates, entity, page, tab, allPages, resources, language);
      return _objectSpread({}, newState);
    }
  }]);
}(_react.Component);
DelegateModal.propTypes = {
  auth: _propTypes["default"].object.isRequired,
  delegates: _propTypes["default"].object.isRequired,
  entity: _propTypes["default"].object,
  fullScreen: _propTypes["default"].bool,
  handleClose: _propTypes["default"].func.isRequired,
  handleRemove: _propTypes["default"].func.isRequired,
  handleResend: _propTypes["default"].func.isRequired,
  handleSend: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  page: _propTypes["default"].object,
  currentFilteredPageList: _propTypes["default"].array,
  allPages: _propTypes["default"].array,
  survey: _propTypes["default"].object.isRequired,
  tab: _propTypes["default"].object
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)((0, _reactRouterDom.withRouter)(DelegateModal));